import React from 'react';
import type { GameState, Color } from '@jester-chess/shared';
import './GameStatus.css';

interface GameStatusProps {
  gameState: GameState;
  yourColor: Color;
}

export const GameStatus: React.FC<GameStatusProps> = ({ gameState, yourColor }) => {
  const isYourTurn = gameState.currentTurn === yourColor;
  const opponentColor = yourColor === 'white' ? 'black' : 'white';

  return (
    <div className="game-status">
      <div className="status-item">
        <span className="label">Your Color:</span>
        <span className={`value color-${yourColor}`}>
          {yourColor.charAt(0).toUpperCase() + yourColor.slice(1)}
        </span>
      </div>
      <div className="status-item">
        <span className="label">Turn:</span>
        <span className={`value ${isYourTurn ? 'your-turn' : 'opponent-turn'}`}>
          {isYourTurn ? 'Your Turn' : `${opponentColor.charAt(0).toUpperCase() + opponentColor.slice(1)}'s Turn`}
        </span>
      </div>
      {gameState.isCheck && (
        <div className="status-item warning">
          <span>⚠️ Check!</span>
        </div>
      )}
      {gameState.isCheckmate && (
        <div className="status-item error">
          <span>♟️ Checkmate!</span>
        </div>
      )}
      {gameState.winner && (
        <div className="status-item winner">
          <span>🏆 {gameState.winner.charAt(0).toUpperCase() + gameState.winner.slice(1)} Wins!</span>
        </div>
      )}
      {gameState.status === 'finished' && !gameState.winner && (
        <div className="status-item">
          <span>Game Finished</span>
        </div>
      )}
    </div>
  );
};

